import React from 'react';
import {BaseLineupPlayersComponent} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mma';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayerFinalTableRow} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-row';

class LineupPlayersComponent extends BaseLineupPlayersComponent {
    getPlayerView(player, lineup) {
        const rowClassName = this.getRowClassName(player);

        return (
            <tr key={player.playerId} className={rowClassName}>
                <td className="nowrap">{player.positionInLineup}</td>
                <td>
                    <strong className="player-name">{player.name}</strong>
                </td>
                <td className="td-team">
                    <TeamLogo teamName={player.opponent} />
                </td>
                <td>{player.getPropValueOfLineupRole('salary')}</td>
                <td>{player.lineupPoints}</td>
                <LineupPlayerFinalTableRow points={player.getPropValueOfLineupRole('fantasyPoints')} />
                <td>{player.projOwn.getValue()}%</td>
                <td className="td-exchange">{this.getExchangePlayerButton({player, lineup})}</td>
            </tr>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
        lineupsData: {lineups},
        filterLineupsByPlayer,
    } = state;

    return {
        sportConfig,
        games,
        lineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
